import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { chatList } from 'modules/actions/chat';
import IconButton from 'components/atoms/Button/IconButton';
import { autoCompleteList, autoCompleteReset, autoCompleteDisplay } from 'modules/actions/autoComplete';
import { isActiveQuickMenu, disableAllMenu, isACtiveVoice, isACtiveIosVoice } from 'modules/actions/statusMenu';
import { currentDevice } from 'modules/actions/deviceEnv';
import AutoComplete from 'components/molecules/AutoComplete';
import ChatMenu from 'components/molecules/ChatMenu';
import { device, getMobileCheck, weBrowser } from 'lib';
/**
 * Chatting:Footer
 */
const ChatFooter = ({ title }) => {
  /** 입력창 Ref */
  const dispatch = useDispatch();

  const inputTextRef = useRef(null);
  const quickState = useSelector(state => state.isActive.quickMenu);
  const [textValue, setTextValue] = useState('');
  const autoCompleteStatus = useSelector(state => state.autoComplete.active);

  const [Icon, setIcon] = useState('');

  /* voice */

  const handleInput = () => {
    const text = inputTextRef?.current?.value.trim();
    setTextValue(text);
    if (text === '') {
      clearInputTextRef();
    } else if (autoCompleteStatus && text) {
      dispatch(autoCompleteList(text));
    }
  };

  const onClickOut = () => {
    dispatch(disableAllMenu());
  };

  /* 하단메뉴 활성화 */
  const onSettingMenu = () => {
    dispatch(isActiveQuickMenu());
  };

  const onVoiceActive = () => {
    dispatch(isACtiveVoice());
  };

  /** 입력창 FOCUS OUT */
  const inputFocusOut = () => {
    const inputDiv = document.querySelector('._send_box');
    inputDiv.classList.remove('active');
    if (device() !== 'pc') {
      setIcon('ri-mic-line');
    }
  };

  /** 입력창 FOCUS IN */
  const inputFocus = () => {
    const inputDiv = document.querySelector('._send_box');
    inputDiv.classList.add('active');
    if (device() !== 'pc') {
      setIcon('ri-arrow-up-line');
    }
  };

  const inpDiv = document.querySelector('._send_box ._send_box_input');
  if (inpDiv) {
    inpDiv.addEventListener('click', inputFocus, false);
  }

  /* 디바이스 터치 이벤트 발생시 */
  const el = document.querySelector('._message_div');
  if (el) {
    el.addEventListener('click', inputFocusOut, false);
  }

  /* input 초기화 */
  const onKeyPressEvt = e => {
    if (e.key === 'Enter' && !e.shiftKey && inputTextRef?.current?.value) {
      onSendMessage();
      clearInputTextRef();
    }
  };

  const clearInputTextRef = () => {
    setTextValue('');
    inputTextRef.current.value = '';
    dispatch(autoCompleteReset());
  };

  const onSendMessage = () => {
    if (textValue !== '') {
      console.log('enter');
      const value = inputTextRef?.current?.value;
      const paramSet = {
        inType: 'query',
        inStr: value,
      };
      dispatch(chatList(paramSet));
      clearInputTextRef();
      if (device() !== 'pc') {
        setIcon('ri-mic-line');
      }
    }
  };

  /**
   *   웹브라우저에서 html element 모두 로딩되고 난 뒤 실행
   */
  document.addEventListener('DOMContentLoaded', () => {
    dispatch(currentDevice(device()));
    if (device() === 'pc') {
      setIcon('ri-arrow-up-line');
    } else {
      setIcon('ri-mic-line');
    }
  });
  return (
    <>
      <footer className="_chat_footer">
        <div className="_menu_btn">
          <IconButton
            icon="ri-apps-line"
            styleDef={{ borderRadius: '40px', border: '0px', backgroundColor: '#fff', color: '#0066CC', fontSize: '30px' }}
            viewStatus=""
            clickEvt={onSettingMenu}
          />
        </div>
        <div className="_send_div">
          <div className="_send_box">
            <input
              type="text"
              placeholder="질문을 입력해 주세요"
              ref={inputTextRef}
              onKeyPress={onKeyPressEvt}
              onChange={handleInput}
              className="_send_box_input"
            />
            <div className="_icon_set">
              {/* 전송버튼 */}
              <IconButton
                icon={device() === 'pc' ? 'ri-arrow-up-line' : Icon}
                styleDef={{
                  borderRadius: '40px',
                  border: '0px',
                  background: 'linear-gradient(to left, #01b1cb, #256eef)',
                  color: '#fff',
                  fontSize: '30px',
                  width: '35px',
                  height: '35px',
                }}
                viewStatus=""
                clickEvt={Icon !== 'ri-mic-line' ? onSendMessage : onVoiceActive}
              />
            </div>
          </div>
        </div>
        <AutoComplete clearInputTextRef={clearInputTextRef} />
        {/*         <div className="_quick_opacity" style={{ display: quickState ? 'block' : 'none' }} onClick={() => onClickOut()}>
          {quickState && (
            <div className="_quick_div">
              <ChatMenu />
            </div>
          )}
        </div> */}
        <div className="_quick_opacity" style={{ display: quickState ? 'block' : 'none' }} onClick={() => onClickOut()} />
        <ChatMenu styleDef={{ height: quickState ? '100px' : '0px' }} />
      </footer>
    </>
  );
};

ChatFooter.propTypes = {
  title: PropTypes.string,
};
ChatFooter.defaultProps = {
  title: '',
};
export default ChatFooter;
